import * as async from "async";
import $ from "jquery";
import * as _ from "underscore";

import * as accountModal from "accountModal";
import * as editCardDialog from "editCardDialog";
import * as keyboardShortcuts from "keyboardShortcuts";
import loadHandwritingFont from "loadHandwritingFont";
import * as localAPI from "localAPI";
import UserWordModel from "models/UserWordModel";
import models from "models/models";
import * as Mustache from "mustache";
import * as mustcache from "mustcache";
import readlangClient from "readlangClient";
import * as languageMap from "shared/languageMap";
import * as signupModal from "signupModal";
import translateErrorHandler from "translateErrorHandler";
import RemoteWordListToolbarView from "views/RemoteWordListToolbarView";
import RemoteWordListView from "views/RemoteWordListView";
import * as walkthrough from "walkthrough";

let translateTimeout;
let translateInput;
let translateOutput;
let translateCount = 0;
let currentResponse = -1;
let pageName = "wordsPage";
let element;
let remoteWordListView;
let remoteWordListToolbarView;
let lastSearchID = 1;

export const name = pageName;

const onLanguageChange = () => {
  window.location.reload();
};

const translate = () => {
  const input = translateInput.val();
  const MAX_LENGTH = 200;
  const thisCount = translateCount;

  translateCount++;

  if (input.length > MAX_LENGTH) {
    translateOutput.text("Maximum length of " + MAX_LENGTH + " characters.");
    return;
  }

  if (input === "") {
    element.find("#addWord").hide();
    translateOutput.text("");
    return;
  }

  readlangClient.request(
    "GET",
    "/api/translate",
    {
      source: models.user.get("currentLearningLanguage"),
      target: models.user.get("firstLanguage"),
      q: input,
    },
    (response) => {
      if (thisCount > currentResponse) {
        currentResponse = thisCount;
        translateOutput.html(response.translations[0]);

        element.find("#addWord").show();

        if (/ /.test(response.translations[0])) {
          element.find("#addWord").text("Learn this phrase");
        } else {
          element.find("#addWord").text("Learn this word");
        }
      }
    },
    (error) => {
      translateErrorHandler(error, models);
    }
  );
};

const wordGroupFilterMap = {
  all: {},
  allPublic: {
    public: true,
  },
  favorite: {
    favorite: true,
  },
  notFavorite: {
    favorite: false,
  },
  readyToTest: {
    wordGroup: "readyToTest",
  },
  notStarted: {
    wordGroup: "notStarted",
  },
  scheduled: {
    wordGroup: "scheduled",
  },
  learning: {
    wordGroup: "learning",
  },
  learned: {
    wordGroup: "mastered",
  },
  deleted: {
    wordGroup: "deleted",
    sortBy: "deletedDate",
  },
  book: function (data) {
    return {
      bookIDs: data,
    };
  },
};
const getWordGroupFilter = () => {
  const checkedValue = element
    .find('input[name="wordFilter"]:checked')
    .attr("value");

  const filter = (checkedValue || "all").split("-");
  const wordGroup = wordGroupFilterMap[filter[0]];

  if (typeof wordGroup === "function") {
    return wordGroup(filter[1]);
  } else {
    return wordGroup;
  }
};

let initialized = false;
const onChangeSearchQuery = () => {
  element.find(".addWordButton").hide();
  element.find(".searchStatus").hide();
  element.find(".didYouMeanLink").hide();

  const newSearchQuery = models.remoteUserWords.searchQuery.get("search");
  element.find('input[name="search"]').val(newSearchQuery);
  if (newSearchQuery) {
    element.find(".clearSearchButton").show();
  } else {
    element.find(".clearSearchButton").hide();
  }
};

export const render = async (containerElement, renderedCallback, appRouter) => {
  if (!initialized) {
    initialized = true;

    models.remoteUserWords.searchQuery.on("change", onChangeSearchQuery);
    models.user.on("change:currentLearningLanguage", onLanguageChange);
  }

  loadHandwritingFont();

  $("title").text("Words - Readlang");

  if (await localAPI.isLocalMode()) {
    containerElement.html(mustcache.render("localModeWordsPage", {}));
    containerElement.find("a.signUp").click(() => {
      event.preventDefault();
      event.stopPropagation();

      signupModal.show({
        headingHtml: "<h2>Let's get started!</h2>",
        models: models,
      });
    });

    renderedCallback();
    return;
  }

  const userJson = models.user.toJSON();
  userJson.currentLearningLanguageString =
    languageMap.map[models.user.get("currentLearningLanguage")].name;
  userJson.firstLanguageString =
    languageMap.map[models.user.get("firstLanguage")].name;
  element = $("<div/>").html(
    mustcache.render("wordsPage", {
      user: userJson,
      localMode: await readlangClient.isLocalMode(),
    })
  );

  containerElement.empty().append(element);
  renderedCallback();

  translateInput = element.find("input[name=translateInput]");
  translateOutput = element.find("span#translation");

  translateInput.keyup(() => {
    clearTimeout(translateTimeout);
    translateTimeout = setTimeout(translate, 400);
  });

  element.find("#addWord").click(() => {
    const word = translateInput.val();
    const translation = translateOutput.text();
    const language = models.user.get("currentLearningLanguage");

    if (word.length === 0) {
      alert("Enter word to translate first");
      return;
    }

    editCardDialog.show(
      new UserWordModel({
        word: word,
        contexts: [
          {
            text: word,
          },
        ],
        translation: translation,
        language: language,
      }),
      {
        title: "Add Word",
        newCard: true,
      }
    );
  });

  element.find("#importWordsButton").click(() => {
    appRouter.navigate("importWords", { trigger: true });
  });

  element.find(".clearSearchButton").click(() => {
    models.remoteUserWords.searchQuery.set({ search: "" });
  });

  const showAddWordDialog = (word, translation) => {
    const language = models.user.get("currentLearningLanguage");

    editCardDialog.show(
      new UserWordModel({
        word: word,
        translation: translation,
        contexts: [
          {
            text: word,
          },
        ],
        language: language,
      }),
      {
        title: `Add New ${/ /.test(word) ? "Phrase" : "Word"}`,
        savedCallback: function () {
          models.remoteUserWords.fetch({
            data: {},
          });
        },
        newCard: true,
      }
    );
  };

  const lookupPhrase = (searchTerm) => {
    const source = models.user.get("currentLearningLanguage");
    const target = models.user.get("firstLanguage");

    async.parallel(
      {
        sourceToTarget: function (callback) {
          readlangClient.request(
            "GET",
            "/api/translate",
            {
              source: source,
              target: target,
              q: searchTerm,
            },
            (response) => {
              callback(null, response);
            },
            (error) => {
              callback(error);
            }
          );
        },
        targetToSource: function (callback) {
          readlangClient.request(
            "GET",
            "/api/translate",
            {
              source: target,
              target: source,
              q: searchTerm,
            },
            (response) => {
              callback(null, response);
            },
            (error) => {
              callback(error);
            }
          );
        },
      },
      (err, result) => {
        if (err) {
          element.find(".addWordButton").hide();
          element.find(".searchStatus").hide();
          translateErrorHandler(err, models, (options) => {
            element.find(".searchStatus").html(options.htmlMessage).fadeIn();
          });
          return;
        }

        let gotTranslation = false;
        if (
          result.sourceToTarget.translations &&
          result.sourceToTarget.translations[0] !== searchTerm
        ) {
          gotTranslation = true;
          const translation = result.sourceToTarget.translations[0];
          element
            .find(".addWordButton.one")
            .html(
              mustcache.render("addWordButton", {
                word: searchTerm,
                type: / /.test(searchTerm) ? "Phrase" : "Word",
                translation: result.sourceToTarget.translations[0],
                currentLearningLanguage: languageMap.map[source].english,
                firstLanguage: languageMap.map[target].english,
              })
            )
            .fadeIn()
            .css("display", "inline-block")
            .off("click")
            .click(() => {
              showAddWordDialog(searchTerm, translation);
            });

          const thisSearchID = lastSearchID;

          // Check spelling of the word
          readlangClient.request(
            "GET",
            "/api/smartDictionary/checkSpelling",
            {
              word: searchTerm,
              translation,
              language: source,
              translationLanguage: target,
            },
            (response) => {
              if (thisSearchID !== lastSearchID) {
                // This result is stale since it references an old search query
                return;
              }

              if (!response.correct) {
                // Add "Did you mean" link
                element
                  .find(".didYouMeanLink")
                  .html(
                    `<a href="#" style="line-height:2.5">Did you mean "${response.corrected}"</a>`
                  )
                  .fadeIn()
                  .find("a")
                  .off("click")
                  .click((event) => {
                    event.stopPropagation();
                    event.preventDefault();

                    models.remoteUserWords.searchQuery.set({
                      search: response.corrected,
                    });

                    element.find(".searchButton").click();
                  });
              }
            }
          );
        }
        if (
          result.targetToSource.translations &&
          result.targetToSource.translations[0] !== searchTerm
        ) {
          gotTranslation = true;
          element
            .find(".addWordButton.two")
            .html(
              mustcache.render("addWordButton", {
                word: result.targetToSource.translations[0],
                type: / /.test(result.targetToSource.translations[0])
                  ? "Phrase"
                  : "Word",
                translation: searchTerm,
                currentLearningLanguage: languageMap.map[source].english,
                firstLanguage: languageMap.map[target].english,
              })
            )
            .fadeIn()
            .css("display", "inline-block")
            .off("click")
            .click(() => {
              showAddWordDialog(
                result.targetToSource.translations[0],
                searchTerm
              );
            });
        }

        if (!gotTranslation) {
          element
            .find(".addWordButton.one")
            .html(
              mustcache.render("addWordButton", {
                word: searchTerm,
                type: / /.test(searchTerm) ? "Phrase" : "Word",
                translation: searchTerm,
                currentLearningLanguage: languageMap.map[source].english,
                firstLanguage: languageMap.map[target].english,
              })
            )
            .fadeIn()
            .css("display", "inline-block")
            .off("click")
            .click(() => {
              showAddWordDialog(searchTerm, searchTerm);
            });
        }
      }
    );
  };

  models.remoteUserWords.fetch({
    success: function (err, group) {
      if (group.count === 0 && !walkthrough.hasAchievement("translate")) {
        element.html(
          '<p class="hintArrow">' +
            '<img src="/content/upArrow.png" style="margin-bottom:20px"></img>' +
            '<span style="margin-left:15px;max-width:400px;position:absolute;bottom:0">Read articles from the <strong><i class="icon-book"></i> Library</strong> first, all the words and phrases you translate will be listed here for you to review and edit here.</span></p>'
        );
        return;
      }

      remoteWordListView = new RemoteWordListView({
        models: models,
        model: models.remoteUserWords,
        wordGroup: "",
        showCancelButton: false,
        maxWords: 10,
        navControls: element.find(".navControls"),
      });
      element.find(".mainWordList").append(remoteWordListView.$el);

      remoteWordListToolbarView = new RemoteWordListToolbarView({
        models: models,
        model: models.remoteUserWords,
        appRouter,
      });

      element
        .find(".wordsToolbarContainer")
        .append(remoteWordListToolbarView.$el);

      const searchInput = element.find('input[name="search"]');

      const search = () => {
        lastSearchID += 1;

        element.find('input[name="wordFilter"]:checked').prop("checked", false);
        const searchTerm = searchInput.val().trim();

        element.find(".addWordButton").hide();
        element.find(".searchStatus").hide();

        models.remoteUserWords.fetch({
          data: {
            search: searchTerm,
          },
          success: function () {
            const lowerCaseWords = _.map(
              models.remoteUserWords.pluck("word"),
              (w) => w.toLowerCase()
            );

            const lowerCaseTranslations = _.map(
              models.remoteUserWords.pluck("translation"),
              (t) => t.toLowerCase()
            );

            const lowerCaseSearchTerm = searchTerm.toLowerCase();

            const exactWordMatch = _.contains(
              lowerCaseWords,
              lowerCaseSearchTerm
            );
            const exactTranslationMatch = _.contains(
              lowerCaseTranslations,
              lowerCaseSearchTerm
            );

            if (!exactWordMatch && !exactTranslationMatch) {
              lookupPhrase(searchTerm);
            }
          },
        });
      };
      searchInput.keyup((event) => {
        element.find(".searchStatus").hide();
        if (event.which === keyboardShortcuts.keyCodes.enter) {
          search();
        }
      });
      element.find(".searchButton").click(() => {
        search();
      });
      element.find(".addWordButton").click(() => {
        const word = searchInput.val();
        const language = models.user.get("currentLearningLanguage");

        editCardDialog.show(
          new UserWordModel({
            word: word,
            context: word,
            language: language,
          }),
          {
            title: `Add New ${/ /.test(word) ? "Phrase" : "Word"}`,
            newCard: true,
          }
        );
      });
    },
  });

  readlangClient.request(
    "GET",
    "/api/booksWithWords",
    {
      language: models.user.get("currentLearningLanguage"),
    },
    (books) => {
      const template =
        "<li>" +
        '<input  id="sidebar-book-{{_id}}" type="radio" name="wordFilter" value="book-{{_id}}"/>' +
        '<label for="sidebar-book-{{_id}}" title="{{title}}">{{title}}</label>' +
        "</li>";

      element.find(".booksWithWordsThrobber").hide();
      _.each(books, (book) => {
        element
          .find(".sidebarList.books")
          .append(Mustache.render(template, book));
      });

      if (
        models.user.get("subscriptionPlan") !== "standard" &&
        models.user.get("subscriptionPlan") !== "plus" &&
        models.user.get("subscriptionPlan") !== "freeForever"
      ) {
        element
          .find('.books input[name="wordFilter"], .books label')
          .click((event) => {
            event.stopPropagation();
            event.preventDefault();

            accountModal.show({
              model: models.user,
              title: "booksFilter",
              messageHtml: "<h2>Upgrade to filter by text...</h2>",
              showTitle: false,
            });
          });
      }
      element.find('input[name="wordFilter"]').change(() => {
        models.remoteUserWords.fetch({
          data: getWordGroupFilter(),
        });
      });
    }
  );
};

export const close = () => {
  if (remoteWordListView) {
    remoteWordListView.remove();
  }
  if (remoteWordListToolbarView) {
    remoteWordListToolbarView.remove();
  }
  models.user.off("change:currentLearningLanguage", onLanguageChange);
  models.remoteUserWords.searchQuery.off("change", onChangeSearchQuery);

  initialized = false;
};

export const showHeader = true;
